<template>
  <div class="dashboard">
    <!-- 统计卡片 -->
    <el-row :gutter="24" class="stats-row">
      <el-col :span="6">
        <el-card shadow="never" class="stat-card">
          <p class="stat-label">今日新增订单</p>
          <div class="stat-value-wrap">
            <span class="stat-value">{{ formatNumber(stats.todayOrderCount) }}</span>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="never" class="stat-card stat-card-danger">
          <p class="stat-label danger">待审核商品数</p>
          <div class="stat-value-wrap">
            <span class="stat-value danger">{{ stats.pendingAuditCount }}</span>
            <span v-if="stats.pendingAuditCount > 0" class="stat-tip">需及时处理</span>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="never" class="stat-card">
          <p class="stat-label">总会员数</p>
          <div class="stat-value-wrap">
            <span class="stat-value">{{ formatNumber(stats.totalMembers) }}</span>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="never" class="stat-card">
          <p class="stat-label">本月平台流水</p>
          <div class="stat-value-wrap">
            <span class="stat-value">¥{{ formatMoney(stats.monthFlow) }}</span>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 交易走势图 -->
    <el-card shadow="never" class="chart-card">
      <div slot="header" class="chart-header">
        <span class="chart-title">平台近7日交易走势</span>
      </div>
      <div ref="chart" style="height: 400px;"></div>
    </el-card>
  </div>
</template>

<script>
import { getDashboard } from '@/api'

export default {
  name: 'Dashboard',
  data() {
    return {
      stats: {
        todayOrderCount: 0,
        pendingAuditCount: 0,
        totalMembers: 0,
        monthFlow: 0
      },
      sevenDayData: [],
      chart: null
    }
  },
  mounted() {
    this.fetchData()
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
    }
  },
  methods: {
    formatNumber(num) {
      if (num >= 10000) {
        return (num / 10000).toFixed(1) + 'w'
      }
      return num.toLocaleString()
    },
    formatMoney(num) {
      if (num >= 10000) {
        return (num / 10000).toFixed(1) + 'w'
      }
      return num.toLocaleString()
    },
    fetchData() {
      getDashboard().then(res => {
        this.stats = {
          todayOrderCount: res.todayOrderCount || 0,
          pendingAuditCount: res.pendingAuditCount || 0,
          totalMembers: res.totalMembers || 0,
          monthFlow: res.monthFlow || 0
        }
        this.sevenDayData = res.sevenDayData || []
        this.initChart()
      }).catch(() => {
        // fallback: 保持静态数据显示
        this.stats = {
          todayOrderCount: 1284,
          pendingAuditCount: 8,
          totalMembers: 856000,
          monthFlow: 24508000
        }
        this.sevenDayData = [
          { date: '06-27', amount: 320, count: 980 },
          { date: '06-28', amount: 280, count: 850 },
          { date: '06-29', amount: 350, count: 1020 },
          { date: '06-30', amount: 410, count: 1180 },
          { date: '07-01', amount: 380, count: 1100 },
          { date: '07-02', amount: 450, count: 1280 },
          { date: '07-03', amount: 520, count: 1400 }
        ]
        this.initChart()
      })
    },
    initChart() {
      const echarts = require('echarts')
      if (this.chart) this.chart.dispose()
      this.chart = echarts.init(this.$refs.chart)
      const dates = this.sevenDayData.map(d => d.date)
      const amounts = this.sevenDayData.map(d => d.amount)
      const counts = this.sevenDayData.map(d => d.count)

      this.chart.setOption({
        tooltip: { trigger: 'axis' },
        legend: {
          data: ['订单金额', '订单数量'],
          bottom: 0
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: dates.length ? dates : ['06-27', '06-28', '06-29', '06-30', '07-01', '07-02', '07-03']
        },
        yAxis: [
          {
            type: 'value',
            name: '金额(万元)',
            axisLabel: { formatter: '{value}' }
          },
          {
            type: 'value',
            name: '数量(单)',
            axisLabel: { formatter: '{value}' }
          }
        ],
        series: [
          {
            name: '订单金额',
            type: 'bar',
            data: amounts.length ? amounts : [320, 280, 350, 410, 380, 450, 520],
            itemStyle: { color: '#E4393C' },
            barWidth: 24
          },
          {
            name: '订单数量',
            type: 'line',
            yAxisIndex: 1,
            data: counts.length ? counts : [980, 850, 1020, 1180, 1100, 1280, 1400],
            smooth: true,
            itemStyle: { color: '#409EFF' }
          }
        ]
      })
      window.addEventListener('resize', () => {
        this.chart && this.chart.resize()
      })
    }
  }
}
</script>

<style scoped>
.stats-row {
  margin-bottom: 24px;
}

.stat-card {
  border: 1px solid #ebeef5;
  border-radius: 8px;
}

.stat-label {
  font-size: 13px;
  color: #909399;
  margin: 0 0 8px;
}

.stat-label.danger {
  color: #E4393C;
}

.stat-value-wrap {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.stat-value {
  font-size: 28px;
  font-weight: bold;
  color: #303133;
}

.stat-value.danger {
  color: #E4393C;
}

.stat-tip {
  font-size: 12px;
  color: #c0c4cc;
  margin-bottom: 4px;
}

.chart-card {
  border-radius: 8px;
}

.chart-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.chart-title {
  font-weight: bold;
  font-size: 16px;
  color: #303133;
}
</style>
